import React, {
    useState, FC, ReactNode, Dispatch, SetStateAction,
} from 'react';
import ClientDashboardContext from './context';
import { useClientLayout } from '../../../hooks/useClientLayout';
import { useClientProfile } from '../../../../../prodivers/clientProfile';
import { getClientId } from '../../../../../utils';
import Preloader from '../../../../../components/Preloader';
import { START_PAGINATION_PAGE } from '../components/OverviewApplications/constants/const';

// 1. Define the shape of the Context Value
interface ClientDashboardContextState {
    clientName: string;
    clientData: any; // Replace 'any' with your specific Client interface if available
    clientId: string | number;
    dfsClientId: string;
    appsPageNumber: number;
    setAppsPageNumber: Dispatch<SetStateAction<number>>;
    containerPageNumber: number;
    setContainerPageNumber: Dispatch<SetStateAction<number>>;
}

// 2. Define the Props for the Provider Component
interface ClientDashboardProviderProps {
    dfsClientId: string;
    children?: ReactNode;
}

const ClientDashboardProvider: FC<ClientDashboardProviderProps> = ({
    dfsClientId,
    children = null,
}) => {
    // State hooks with explicit types
    const [appsPageNumber, setAppsPageNumber] = useState<number>(START_PAGINATION_PAGE);
    const [containerPageNumber, setContainerPageNumber] = useState<number>(START_PAGINATION_PAGE);

    // Initialize layout logic
    useClientLayout();

    // Client Profile Context
    const {
        clientName,
        data: clientData,
        overviewError,
    } = useClientProfile() as {
        clientName: string;
        data: any;
        overviewError: any;
    };

    const clientId = getClientId(dfsClientId);

    // 3. Construct the state object following the Interface
    const state: ClientDashboardContextState = {
        clientName,
        clientData,
        clientId: clientId as number,
        dfsClientId,
        appsPageNumber,
        setAppsPageNumber,
        containerPageNumber,
        setContainerPageNumber,
    };

    return (
        <ClientDashboardContext.Provider value={state}>
            <Preloader isLoading={false} error={overviewError}>
                {children}
            </Preloader>
        </ClientDashboardContext.Provider>
    );
};

export default ClientDashboardProvider;
